import PropTypes from 'prop-types';
import { Link } from '@mui/material';

// ----------------------------------------------------------------------

DIOText.propTypes = {
  sx: PropTypes.object,
};

export default function DIOText({ sx }) {
  return (
    <Link
      underline="none"
      sx={{ 
        fontFamily: (theme) => theme.typography.subFontFamily,
        color: 'inherit',
        ...sx,
      }}>
        DIO
    </Link>
  );
}
